import styled from 'styled-components';
import defaultTheme from '../../config/theme';

const OptionElement = styled.button`
  background: ${props => {
    if (props.variant === 'rate' && props.clickable)
      return 'buttonface';
    if (props.variant === 'rate' && !props.clickable)
      return 'none';
    return props.theme.botBubbleColor;
  }};
  border: 0;
  border-radius: 22px;
  box-shadow: ${props => {
    if (props.variant === 'rate' && !props.clickable)
      return 'none';
    return '0 1px 2px 0 rgba(0, 0, 0, 0.15)';
  }};
  color: ${props => {
    if (props.variant === 'rate')
      return 'rgb(255, 255, 255)';
    return props.theme.botFontColor;
  }};
  display: inline-block;
  font-size: 14px;
  padding: ${props => {
    if (props.variant === 'rate' && props.clickable)
      return '6px';
    if (props.variant === 'rate' && !props.clickable)
      return '0';
    return '12px';
  }};
  cursor: ${props => (!props.clickable ? 'default' : 'pointer')};

  &:focus{
    background: ${props => {
      if (props.variant === 'rate' && props.clickable)
        return 'buttonface';
      if (props.variant === 'rate' && !props.clickable)
        return 'none';
      return props.theme.botBubbleColor;
    }};
  }
  &:hover {
    opacity: ${props => (!props.clickable ? '1' : '0.7')};
  }
  &:active,
  &:hover:focus {
    outline:none;
  }
`;

OptionElement.defaultProps = {
  theme: defaultTheme
};

export default OptionElement;